
// StatusBadge.js - Componente para exibir badge de status
import React from 'react';
import { getStatusConfig } from './StatusConfig';
import { DocumentPlusIcon, CogIcon, CheckCircleIcon } from './Icons';

const StatusBadge = ({ status, size = 'sm', showIcon = true, className = '' }) => {
  const config = getStatusConfig(status);

  const IconComponent = {
    DocumentPlusIcon,
    CogIcon, 
    CheckCircleIcon
  }[config.icon] || DocumentPlusIcon;

  const sizeClasses = {
    xs: 'px-2 py-1 text-xs',
    sm: 'px-2.5 py-1.5 text-sm',
    md: 'px-3 py-2 text-base',
    lg: 'px-4 py-2.5 text-lg'
  };

  const iconSizes = {
    xs: 'h-3 w-3',
    sm: 'h-4 w-4', 
    md: 'h-5 w-5',
    lg: 'h-6 w-6'
  };

  return (
    <span
      className={`
        inline-flex items-center gap-1.5 rounded-full font-medium
        ${config.bgColor} ${config.textColor} ${config.borderColor}
        border ${sizeClasses[size]} ${className}
      `}
      title={config.description}
    >
      {showIcon && <IconComponent className={iconSizes[size]} />}
      {config.label}
    </span>
  );
};

export default StatusBadge;
